export default __webpack_public_path__ + "static/media/calling_coderegular.466d0877.txt";